<template>    
    <div  style="position:absolute;left:-5000px;top:-5000px;width:200px;height:200px" >       
      <mission-scatter-plot-web-gl
              :sciGraph="sciGraph"                 
              :simuGraph="simuGraph"                 
              :pointSize="3" 
              :abscisseVariable="abscisseVariable"
              :ordonneeVariable="ordonneeVariable"
              :colorVariable="colorVariable"
              :uiid="uiid" 
              :prefixe="prefixe"
              :allowClick="false"
              :allowZoom="false"                        
              :marginWidth="15"   
              :offsetLegendX="10"
              :offsetLegendY="5"  
              :colorGradientWidth="10"            
              :offsetLegendColor="5"      
              :xTicks="8"
              :useCacheImg="false"
              :redraw="false"              
              :dataLimit="dataLimit"
              :autoScaleX="graphHover.autoScaleX"                
              :autoScaleY="graphHover.autoScaleY"
              :graphHoverMode="true"
              :mission="mission"
              :tabState="tabState"
              />     
  </div>
</template>
<script lang="ts">      
  import { AloMission } from '@/models/alo/AloMission'        
  import Vue from 'vue'  
  import Component from 'vue-class-component'  
  import MissionScatterPlotWebGl from '@/components/charts/MissionScatterPlotWebGl.vue'
import { dataLimitMode } from '@/models/ui/GraphUiState'

@Component({
    name: 'MissionGraphHoverData', 
    props:  {
      prefixe:{
        type:String,
        default: ''
      },
      uiid:{
          type: String,
          required: true
      },
      sciGraph:{
        type:Boolean,
        default:true
      },
      simuGraph:{
        type:Boolean,
        default:false
      },
      dataLimit:{
        type:String,
        default:dataLimitMode.ALL
      },
      mission:{
        type:AloMission,
        required:true
      },
      tabState:{
        required:true
      }
    },
    components:{MissionScatterPlotWebGl}
  })
  export default class MissionGraphHoverData extends Vue {  

    sciGraph!:boolean
    simuGraph!:boolean
    uiid!:string
    prefixe!:string
    dataLimit!:string
    mission!:AloMission
    tabState!:any
        
    get plotVariables(){        
        return this.sciGraph?this.mission.sciPlotVariables:this.simuGraph?this.mission.simuPlotVariables:this.mission.navPlotVariables
    }
    
    
    get ordonneePlotvariable() {        
      return this.plotVariables.find(v => v.variable == this.graphHover.variableY)
    }   

    get abscisseVariable(){               
      return this.datas.some(d => !!d[this.graphHover.variableX])?this.graphHover.variableX:(this.sciGraph?"NAV_DEPTH":this.simuGraph?"datSimu":"datNav")
    }

    get ordonneeVariable(){
      //@ts-ignore
      if((this.ordonneePlotvariable?.variables?.length ?? 0) > 0)
      {
        //@ts-ignore
        if(this.datas.some(d => !!d[this.ordonneePlotvariable.variables[0]])) return this.graphHover.variableY
      }
      else {
        if(this.datas.some(d => !!d[this.graphHover.variableY])) return this.graphHover.variableY
      }
      return this.sciGraph?"NAV_DEPTH":this.simuGraph?"duration":"roll"
    }


    get colorVariable(){
      return (!!this.datas[0][this.graphHover.variableColor])?this.graphHover.variableColor:"None"
    }
    

    get datas(){
      return this.sciGraph?this.mission.dataScience:this.simuGraph?this.mission.dataSimulation:this.mission.dataNavigation
    }

    

    get graphHover() {
      return  this.$store.myGetters.graphHover
    }
    
  }
</script>